require('./availPromotionSuccessStep.scss');

// @vendor
const PropTypes = require('prop-types');
const classNames = require('classnames');
const React = require('react');
// @commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
//components
const { AvailPromotionBox } = require('./availPromotionBox');
//constants
const {
    PROFILE_EDIT_FORMS: {
        ADDRESS,
        EMAIL,
        PHONE
    }
} = require('constants/myProfileEditor');
// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatText, FormattedText } = require('core/i18n').i18n;

class AvailPromotionSuccessStep extends React.Component {

    componentWillUnmount() {
        this.props.resetAdvancedInterstitialFlag();
    }

    buildEditorSuccessChangedData() {
        const { immProfileEditor, immProfileFields } = this.props;
        const immStep = immProfileEditor.getIn(['steps', 0]);
        const editMode = immProfileEditor.get('editMode');
        let formInputs;

        switch (editMode) {
            case EMAIL:
                formInputs = ['email'];
                break;
            case PHONE:
                formInputs = [
                    'phoneCode',
                    'phoneNumber',
                ];
                break;
            case ADDRESS:
                formInputs = [
                    'locality',
                    'numberStreet',
                    'postalCode',
                    'province',
                    'streetName',
                    'typeOfRoads'
                ];
                break;
        }

        const formInputsChangedData = {};
        formInputs.forEach(input => {
            const actualState = immStep.get(input);
            formInputsChangedData[input] = actualState;
        });
        const {
            email,
            phoneCode,
            phoneNumber
        } = formInputsChangedData;
        const fullPhoneNumberItem = (phoneCode || phoneNumber) && this.buildListItem('profile-contactData_new_phone', PersonalDataHelper.getMaskedPhone(immStep.get('phoneCode') + immStep.get('phoneNumber')));
        const addressItem = editMode === ADDRESS && this.buildListItem('profile-contactData_new_address', PersonalDataHelper.getFormattedAddress(immProfileFields));
        const emailItem = email && this.buildListItem('profile-contactData_email', immStep.get('email'));
        let contactData;
        let firstColumn = null;

        if (fullPhoneNumberItem || addressItem || emailItem) {
            if (fullPhoneNumberItem || emailItem) {
                firstColumn = (
                    <React.Fragment>
                        {fullPhoneNumberItem}
                        {emailItem}
                    </React.Fragment>)
            }
            contactData = (
                <OKInformativeList columns={2}>
                    {firstColumn}
                    {addressItem}
                </OKInformativeList>
            );
        }

        return (
            <div className="avail-promotion-success-step__updated-date">
                {contactData}
            </div>
        );
    }

    buildListItem(title, body) {
        const { bodyWordBreak } = this.props;
        return (
            <OKInformativeListItem
                title={formatText(title)}
                bodyWordBreak={bodyWordBreak}
                bodyText={<span className="confirm-success-step__show-text-one-line">{body}</span>}
            />
        );
    }

    render() {

        const {
            alreadyUpdated,
            immProfileEditor,
            isPromotionHired,
            mainProfileView
        } = this.props;
        const editMode = immProfileEditor.get('editMode');
        const mainButton = {
            label: <FormattedText value="availPromotionSuccessStep-availPromotionSuccessStep_backButtonLabel" />,
            url: 'myprofile/edit'
        };
        const confirmSuccessClass = classNames('col-xs-offset-2', 'col-xs-8', {
            'confirm-success-step': mainProfileView
        });
        let formDataChanged;
        let successMessage;

        if (alreadyUpdated) {
            successMessage = formatText('availPromotionSuccessStep-availPromotionSuccessStep_profileAlreadyUpdatedTitle')
        } else {
            formDataChanged = this.buildEditorSuccessChangedData();
            let editModeTitle;
            if (editMode === EMAIL) {
                editModeTitle = 'updatedEmailTitle';
            } else if (editMode === ADDRESS) {
                editModeTitle = 'updatedAddressTitle';
            } else if (editMode === PHONE) {
                editModeTitle = 'updatedPhoneTitle';
            }
            successMessage = formatText(`availPromotionSuccessStep-availPromotionSuccessStep_${editModeTitle}`);
        }

        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className={confirmSuccessClass}>
                            <WizardSuccess
                                successMessage={successMessage}
                                mainButton={mainButton}
                            >
                                {formDataChanged}
                                <AvailPromotionBox promotionAlreadyAvailed={isPromotionHired} alreadyUpdated={alreadyUpdated} />
                            </WizardSuccess>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

AvailPromotionSuccessStep.propTypes = {
    alreadyUpdated: PropTypes.bool,
    bodyWordBreak: PropTypes.bool,
    columns: PropTypes.oneOf([1, 2, 3, 4]),
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    isPromotionHired: PropTypes.bool,
    mainProfileView: PropTypes.bool,
    onConfirmLeave: PropTypes.func.isRequired,
    resetAdvancedInterstitialFlag: PropTypes.func.isRequired
};

AvailPromotionSuccessStep.defaultProps = {
    alreadyUpdated: false,
    bodyWordBreak: true,
    columns: 2,
    isPromotionHired: false,
    mainProfileView: true,
};

module.exports = AvailPromotionSuccessStep;
